import { Box } from '@mui/material'
import React from 'react'
import CONSTANTS from '../../../../Constants'

interface BadgeProps {
  text: string // Ensure text is required
  color?: 'success' | 'primary' | 'warning' | 'error' | 'black' | 'accentGreen' | 'accentYellow' // Default to MUI theme colors
}

const CommonBadge: React.FC<BadgeProps> = ({ text, color = 'primary' }) => {
  if (!text) return null // Prevent rendering if text is missing

  const colors: Record<string, { bg: string; text: string; border: string }> = {
    success: { bg: '#f4f9ea', text: '#4c6a0b', border: '1px solid #4c6a0b' },
    primary: { bg: '#ece9f2', text: '#402080', border: '1px solid #402080' },
    warning: { bg: '#fff3cd', text: '#856404', border: '1px solid #ffc107' },
    error: { bg: '#ffdbd5', text: '#d4351c', border: '1px solid #d4351c' },
    black: { bg: '#DDDDDE', text: '#383F43', border: '1px solid #383F43' },
    accentGreen: { bg: '#E6EFEA', text: '#005A30', border: 'none' },
    accentYellow: { bg: '#FFF7E6', text: '#CC8F00', border: 'none' },
  }

  const { bg, text: textColor, border } = colors[color] || colors['primary']

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: '9px',
        lineHeight: '22px',
        borderRadius: '4px',
        fontSize: '12px',
        fontWeight: 400,
        backgroundColor: bg,
        color: textColor,
        border: border,
        fontFamily: 'Inter, sans-serif',
      }}
    >
      {text}
    </Box>
  )
}

export default CommonBadge

export const getSNPBadge = (status: string) => {
  let snpStatus: string | React.ReactNode = CONSTANTS.DEFAULT_TEXT
  if (status) {
    if (String(status).toLowerCase() === 'approved') {
      snpStatus = CommonBadge({ text: 'Accepted', color: 'accentGreen' })
    } else if (String(status).toLowerCase() === 'pending') {
      snpStatus = CommonBadge({ text: 'Pending Approval', color: 'accentYellow' })
    } else {
      snpStatus = CommonBadge({ text: status, color: 'black' })
    }
  }
  return snpStatus
}
